import {useMemo} from 'react';

import {DeletePartner, DeletionSubmissionFormData} from './types';

type DeletePartnerId = `delete_partner_${string}`;
export const createDeletePartnerId = (mid: string): DeletePartnerId =>
    `delete_partner_${mid}`;
export const isDeletePartnerId = (key: string) =>
    key.includes('delete_partner');

export const createPartnerIds = (
    partners: DeletePartner[],
): DeletePartnerId[] =>
    partners.map((partner) => createDeletePartnerId(partner.mid));

const createDeletePartnerObject = (
    partners: DeletePartner[],
): Record<string, boolean> => {
    const partnerIds = createPartnerIds(partners);

    return Object.fromEntries(partnerIds.map((id) => [id, false]));
};

export const getPartnerObjectFromObject = (
    data: object,
): Record<string, boolean> =>
    Object.fromEntries(
        Object.entries(data)
            .filter(([key]) => isDeletePartnerId(key))
            .map(([key, value]) => [key, !!value]),
    );
/**
 * Generate default values for the deletion confirm form
 */
const useDeletionConfirmFormDefaultValues = (
    partners: DeletePartner[],
): DeletionSubmissionFormData =>
    useMemo(() => {
        const partnerObject = createDeletePartnerObject(partners);

        return {
            delete_user: false,
            improvements: '',
            reason_detail: '',
            selected_reason: null,
            ...partnerObject,
        };
    }, []);

export default useDeletionConfirmFormDefaultValues;
